<div class="d-flex justify-content-between align-items-center bg-secondary mt-3 w-100 text-white px-4 py-2"
    *ngIf="students.length > 0">
    <label class="fs-5 m-0"><span class="vag-bold-font">TEMÁTICAS</span> {{students[studentCurrent].fullname}}</label>
    <div class="d-flex">
        <button [disabled]="!students[studentCurrent - 1]" class="btn mx-1" (click)="decreaseIndex()">
            <fa-icon [icon]="chevronLeft" class="text-white"></fa-icon>
        </button>
        <button [disabled]="!students[studentCurrent + 1]" class="btn mx-1" (click)="increaseIndex()">
            <fa-icon [icon]="chevronRight" class="text-white"></fa-icon>
        </button>
    </div>
</div>
<div>
    <div class="my-3" *ngIf="courseCurrent">
        Curso: <select (change)="chooseCourse($event)">
            <option *ngFor="let course of students[studentCurrent]?.courseInfoArr" value="{{course.id}}">
                {{course.description}}</option>
        </select> {{courseCurrent.centerDescr}} {{showCourseDays(courseCurrent)}} {{showCourseShedule(courseCurrent)}}
    </div>
    <div class="pt-3">
        <div class="d-flex border-bottom pb-2 border-black">
            <div class="col-4 vag-bold-font">
                Temática
            </div>
            <div class="col-4 vag-bold-font">
                Proyecto
            </div>
            <div class="col-4 vag-bold-font">
                Tipología
            </div>
        </div>
        <div class="d-flex border-bottom pb-2 border-black mt-2" *ngFor="let item of courseCurrent?.projects">
            <div class="col-4 px-1">
                {{item?.temathic?.name}}
            </div>
            <div class="col-4 px-1">
                {{item?.project?.project}}
            </div>
            <div class="col-4 px-1">
                {{item?.tipology?.name}}
            </div>
        </div>
        <!-- *ngIf="showButtonCompleteInscription(course.id)" -->
        <!-- <div *ngIf="checkIfIsTest()" class="d-flex justify-content-between pb-2 border-black mt-2">
            <button type="button" class="close" class="btn btn-primary" (click)="liberarPlaza()">
                Cambiar curso
            </button>

            <button type="button" class="close" class="btn btn-primary"
                (click)="completarInscription(courseCurrent.id)">
                Confirmar y pagar
            </button>
        </div> -->
    </div>
</div>
<div *ngIf="cargando" class="cargando">
    <mat-spinner></mat-spinner>
</div>